import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { AdPlacement, SraPlacement } from '@/@types/graphql-types';
import SponsoredRecommendation from '@/features/sponsored-recommendations/components/SponsoredRecommendation.vue';
import { useSendBidId } from '@/features/sponsored-recommendations/composables/useSendBidId';
import { useGetSrPlacement } from '@/features/sponsored-recommendations/composables/useGetSrPlacement';
import adminConfig from '@/features/promotions/config.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHome',
  setup(__props) {

const GlobalHomeNew = () =>
	import(/* webpackChunkName: "global-home-new" */ '@/features/global-home/components/GlobalHomeNew.vue');
const GlobalHomeLegacy = () =>
	import(/* webpackChunkName: "global-home-legacy" */ '@/features/global-home/components/GlobalHomeLegacy.vue');

const NEW_START_PAGE_COUNTRIES = ['DE', 'AU', 'GB', 'NZ', 'US'];

const { country } = storeToRefs(useLanguageStore());

const isNewStartPage = computed(() => NEW_START_PAGE_COUNTRIES.includes(country.value));

// ** SRs Adserver Migration ** //
const homeGlobalSrConfig = adminConfig?.ad_server?.srs?.placements?.home_global_sr;
const useAdserverSrMutation = computed(
	() => homeGlobalSrConfig?.all_countries || homeGlobalSrConfig?.countries?.includes(country.value)
);

// Be mindful that GlobalHomeLegacy has no active SRs or SR designs
// For SRs can only be run in `NEW_START_PAGE_COUNTRIES`
const { sponsoredAd } = useAdserverSrMutation.value
	? useGetSrPlacement({
			pageType: 'VIEW_HOME_GLOBAL',
			placement: SraPlacement.HomeGlobal,
			adPlacement: AdPlacement.HomeGlobalSr,
	  })
	: useSendBidId({
			pageType: 'VIEW_HOME_GLOBAL',
			placement: SraPlacement.HomeGlobal,
	  });

return { __sfc: true,GlobalHomeNew, GlobalHomeLegacy, NEW_START_PAGE_COUNTRIES, country, isNewStartPage, homeGlobalSrConfig, useAdserverSrMutation, sponsoredAd, SraPlacement, SponsoredRecommendation }
}

})